import { seoLinks, ogImage } from "@/lib/seo";
import { createFileRoute } from "@tanstack/react-router";

import { SchoolYearDates } from "@/components/site/SchoolYearDates";
import { SchoolYearLegacy } from "@/components/site/SchoolYearLegacy";
import { schoolTermsQuery } from "@/lib/school-calendar-query";
import { safeLoader } from "@/lib/safe-loader";
import { CtaBand, PageHero, Prose } from "@/components/site/Page";

const TITLE = "Calendario escolar | Swedish International School";
const DESCRIPTION =
  "Fechas de inicio y fin de curso, vacaciones y días festivos en el colegio sueco entre Estepona y Marbella, con el calendario completo del curso escolar.";

export const Route = createFileRoute("/es/calendario-escolar")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
      { property: "og:locale", content: "es_ES" },
      ...ogImage(),
    ],
    links: seoLinks("/es/calendario-escolar"),
  }),
  loader: ({ context }) => safeLoader("es.school-terms", () => context.queryClient.ensureQueryData(schoolTermsQuery("es")), { terms: [], fetchedAt: null }),
  component: CalendarioEscolar,
});

function CalendarioEscolar() {
  const terms = Route.useLoaderData().terms;

  return (
    <>
      <PageHero
        eyebrow="Calendario"
        title="Calendario escolar"
        intro="Aquí encontrarás las fechas de inicio y fin de cada periodo, las vacaciones y los días sin clase."
      />

      <SchoolYearDates locale="es" terms={terms} />

      <SchoolYearLegacy />

      <Prose>
        <h2>Vacaciones y festivos</h2>
        <p>
          El calendario combina los requisitos de la enseñanza sueca con los festivos locales de
          Andalucía. En los días sin clase no hay comedor ni actividades extraescolares.
        </p>
        <h2>Empezar a mitad de curso</h2>
        <p>
          Es posible empezar durante el curso. En ese caso ajustamos la tarifa según las semanas
          restantes; puedes verlo directamente en{" "}
          <a className="text-primary link-quiet" href="/es/solicitud">el formulario de solicitud</a>.
        </p>
      </Prose>

      <CtaBand locale="es" />
    </>
  );
}
